var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.curWebsite.type == 1)?_c('zhaoshangdanao'):(_vm.curWebsite.type == 6)?_c('chanyeyanjiu'):(_vm.curWebsite.type == 5)?_c('chanyetouzi'):_c('zhaoshangdanao')],1)}
var staticRenderFns = []

export { render, staticRenderFns }